import React, { useRef } from 'react';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../primitives/Center/styled.es.js';
import { Group } from '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import { VisuallyHidden } from '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import '../../primitives/Pin/Pin.es.js';
import { Wrapper } from './styled.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const DropzoneContent = ({ children }) => /* @__PURE__ */ React.createElement(Group, {
  direction: "vertical"
}, children && Array.isArray(children) ? children.map((child, index) => /* @__PURE__ */ React.createElement(Group.Item, {
  key: index
}, child)) : /* @__PURE__ */ React.createElement(Group.Item, null, children));
const DropzoneIcon = (_a) => {
  var _b = _a, { icon: IconComponent } = _b, props = __objRest(_b, ["icon"]);
  return /* @__PURE__ */ React.createElement(Box, {
    flex: "1",
    justifyContent: "center",
    display: "flex"
  }, /* @__PURE__ */ React.createElement(IconComponent, __spreadValues({}, props)));
};
const Dropzone = ({
  isLoading,
  isInvalid,
  children,
  wrapperProps,
  inputProps
}) => {
  const inputRef = useRef(null);
  const handleClickWithRef = () => {
    if (inputRef && inputRef.current && wrapperProps && wrapperProps.onClick) {
      wrapperProps.onClick(inputRef);
    }
  };
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadProps(__spreadValues({}, wrapperProps), {
    p: "xl",
    onClick: handleClickWithRef,
    isLoading,
    isInvalid
  }), /* @__PURE__ */ React.createElement(VisuallyHidden, null, /* @__PURE__ */ React.createElement("input", __spreadProps(__spreadValues({}, inputProps), {
    style: { display: "none" },
    type: "file",
    ref: inputRef
  }))), children);
};
Dropzone.Content = DropzoneContent;
Dropzone.Icon = DropzoneIcon;
Dropzone.displayName = "Dropzone";

export { Dropzone };
//# sourceMappingURL=Dropzone.es.js.map
